import { Modal } from 'antd'
import React, { useState } from 'react'
import { AiFillCloseCircle } from 'react-icons/ai'
import { useGlobal } from '../../core/GlobalContext'
import DealFooterAttribute from '../dealFooterAttribute'
import KeyRisk from '../keyRisk'
import LeaseRepaymentTable from '../leaseRepaymentTable'
import PdfViewer from '../pdfViewer'
import RepaymentTable from '../repaymentTable'
import * as styles from './DealFooter.css'

export const DealFooter = ({ footer, showSummary, setShowSummary, purchaseAmount }) => {
  // Contains type from Footer parser
  const [modalType, setModalType] = useState()

  // Values of said types needs to be converted to url, reference docUrlMap
  const documentIDTypesList = ['dealReport', 'debtTerms']

  const {
    documentsState: { docUrlMap },
  } = useGlobal()

  return (
    <>
      <div className={styles.dealFooter}>
        {footer?.map(({ type, title, val }) => (
          <DealFooterAttribute
            key={type}
            type={type}
            title={title}
            val={documentIDTypesList.includes(type) ? docUrlMap[val]?.url : val}
            showSummary={showSummary}
            setModalType={setModalType}
            setShowSummary={setShowSummary}
          />
        ))}
      </div>
      {modalType && (modalType.type === 'dealReport' || modalType.type === 'debtTerms') ? (
        <PdfViewer open url={modalType.val} title={modalType.title} onClose={() => setModalType()} />
      ) : modalType ? (
        <Modal
          title={modalType.title}
          open={modalType}
          onCancel={() => setModalType()}
          footer={null}
          width={1000}
          closeIcon={<AiFillCloseCircle size='var(--modal-close-icon-size)' />}
          bodyStyle={{ maxHeight: '80vh', overflowY: 'scroll', padding: '1rem 1.5rem' }}>
          {modalType.type === 'risks' ? (
            <KeyRisk />
          ) : modalType.type === 'repaymentTable' ? (
            // purchaseAmount passed will overwrite any values parsed down from Parsers, used in case of multiple Debt Deal Lots
            <RepaymentTable {...modalType.val} purchaseAmount={purchaseAmount?.replace(/,/g, '')} />
          ) : modalType.type === 'leaseRepaymentTable' ? (
            <LeaseRepaymentTable deal={modalType.val} purchaseAmount={purchaseAmount?.replace(/,/g, '')} />
          ) : null}
        </Modal>
      ) : null}
    </>
  )
}
